import React from 'react'
// import Routes from '../router'
import Home from './screen/home'
// import BlogNavbar from './navbar'

function App() {
  return (
    <Home />
    // <Routes>
    //   {/* <Background /> */}
    //   {/* <BlogNavbar /> */}
    // </Routes>
  )
}

export default App
